// extracted by mini-css-extract-plugin
export default {"ctn":"battary_ctn__2EvqI","content":"battary_content__JHZWL","text":"battary_text__ROXST","textBox":"battary_textBox__58JPL"};